import React from 'react';

import COLORS from '~/constants/colors';
import { FONT_SIZES } from '~/constants/typography';
import Button from '~/components/buttons/Button';

interface RemoveProps {
  totalLines: number;
  onDelete: (event: Event) => void;
  disabled?: boolean;
}

function Remove({ totalLines, onDelete, disabled }: RemoveProps) {
  const finalDisabled = disabled || totalLines < 2;

  // Handlers
  const handleDelete = (event) => {
    if (!finalDisabled) onDelete(event);
  };

  // Styling
  const removeStyle = {
    display: 'inline-block',
    position: 'relative' as const,
    verticalAlign: '1.3em',
    width: '2.2em',
    marginLeft: '0.5em',
  };
  const buttonStyle = {
    position: 'absolute' as const,
    top: 0,
    left: 0,
    width: '2em',
    height: '2em',
    padding: '0.2em',
    fontSize: FONT_SIZES.text,
    color: COLORS.tundora,
    backgroundColor: COLORS.white,
    borderColor: COLORS.doveGray,
    borderWidth: '1.5px',
    borderRadius: '0.4em',
    boxShadow: `-0.07em 0.07em ${COLORS.black50}`,
    verticalAlign: 'middle',
  };

  return (
    <div style={removeStyle}>
      {!finalDisabled && (
        <Button label="🗑" callback={handleDelete} style={buttonStyle} />
      )}
    </div>
  );
}

export default Remove;
